import "./i18n";
import App from "./App";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "src/components/Shared/ScrollToTop";
import ThemeUsage from "src/components/ThemeUsage/ThemeUsage";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeUsage>
        <ScrollToTop />
        <App />
      </ThemeUsage>
    </BrowserRouter>
  </React.StrictMode>
);
